import { ReactNode, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'

import { format } from 'date-fns'
import { BackButton } from '../../components/button/backButton'
import { Status } from '../../components/cards/statusTag'
import Spinner from '../../components/spinner/Spinner'
import { formatCurrency } from '../../helpers'
import { useGetSingleTransactionQuery } from '../../redux-toolkits/transactions/transactions.slice'

export const SingleTransactionPage = () => {
  const { id } = useParams()

  const [details, setDetails] = useState<
    { title: string; value: ReactNode | string }[]
  >([])

  const { data: transactionDetails, isFetching: fetchingTransactionDetails } =
    useGetSingleTransactionQuery(
      {
        id: id,
      },
      {
        refetchOnMountOrArgChange: true,
      },
    )

  useEffect(() => {
    if (transactionDetails?.data) {
      setDetails([
        {
          title: 'Transaction ID:',
          value: transactionDetails.data._id,
        },
        {
          title: 'Reference:',
          value: transactionDetails.data.reference,
        },
        {
          title: 'Amount:',
          value: formatCurrency(transactionDetails.data.amount),
        },
        {
          title: 'Status:',
          value: (
            <Status
              text={transactionDetails.data.status}
              type={
                transactionDetails.data.status.toLowerCase() === 'completed'
                  ? 'success'
                  : 'warn'
              }
            />
          ),
        },
        {
          title: 'Payment Method:',
          value: transactionDetails.data.type,
        },

        {
          title: 'Date:',
          value: format(transactionDetails.data.createdAt, 'dd MMM, yyyy'),
        },
        {
          title: 'Customer Name:',
          value: `${transactionDetails?.data?.userId?.firstname ?? ''} ${
            transactionDetails?.data?.userId?.lastname ?? ''
          }`,
        },
        {
          title: 'Customer Email:',
          value: `${transactionDetails?.data?.userId?.email ?? ''}`,
        },
      ])
    }
  }, [transactionDetails])

  return (
    <Layout>
      <div className="flex flex-col gap-10">
        <BackButton />

        <div className="flex items-center justify-between gap-4">
          <PageHeader title="Transaction Details" className="!mb-0" />
        </div>

        {fetchingTransactionDetails ? (
          <Spinner fullScreen={false} />
        ) : (
          <div className="flex flex-col w-full max-w-[800px]">
            {details.map((detail, idx) => {
              const key = `${detail.title}-${idx}`

              return (
                <div
                  className="
                py-4
                first:pt-0 last:pb-0
                border-b last:border-b-0
                flex gap-4
                items-center justify-between
                "
                  key={key}
                >
                  <span className="text-sec-black">{detail.title}</span>
                  <span className="text-black font-medium">{detail.value}</span>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </Layout>
  )
}
